const FLEET_MANAGEMENT_PAGE = {
  pageTitle: 'Gestão de Frota',
  welcomeText:
    'Confira como fazer o gerenciamento da sua frota em um único lugar',
  toolsText: 'Gerenciamento da Minha Frota',
  otherTools: 'Outras Ferramentas',
  tools: {
    myFleet: 'Gerenciar \n Minha Frota',
    myFleetSubpages: {
      generalReport: 'Relatório geral',
      manageCouriers: 'Gerenciar pessoas',
      paymentModels: 'Modelos de pagamento',
    },
    newPerson: 'Adicionar \n Nova Pessoa',
  },
  noDeliverymanPageTitle: 'Minha Frota',
  noDeliverymanLinkedTitle:
    'Sua loja não possui pessoas entregadoras aprovadas',
  noDeliverymanLinkedText:
    'Comece a adicionar sua frota de pessoas \n entregadoras para atuarem na sua loja',
  defaultButton: 'Adicionar frota',
  paymentModels: {
    title: 'Modelos existentes',
    introduction:
      'Crie Modelos de Pagamento que você já ultiliza na sua loja e conecte a sua frota de pessoas entregadoras a eles.',
    modelDescription: 'Composição do pagamento',
    amountPerOrder: 'Valor pago por pedido',
    amountPerDay: 'Valor pago por diária',
    amountPerCancellation: 'Valor pago por pedido cancelado',
    createModelButton: 'Criar modelo',
    createNewButton: 'Criar novo',
    searchPlaceholder: 'Procurar pessoa entregadora',
    linkYourFleet: 'Conectado ao modelo',
    linkYourFleetDescription:
      'Selecione se você quiser conectar a pessoa entregadora ao modelo atual',
    applyAllFleet: 'Aplicar a toda frota',
    defaultModel: 'Exemplo sugerido',
    modelCreated: 'Modelo criado com sucesso',
    createPaymentModel: {
      back: 'Novo modelo',
      nameModel: 'Nome do modelo',
      paymentModel: 'Composição do pagamento',
      orderValue: 'Valor pago por pedido',
      dailyValue: 'Valor da diária',
      cancelledOrderValue: 'Valor pago por pedidos cancelados',
      buttonTitle: 'Avançar',
    },
  },
}

export default FLEET_MANAGEMENT_PAGE
